import { call, put, takeLatest } from "redux-saga/effects";
import request from "utils/request";
import { companiesActions } from "./index";
import { showToast } from "components/ToastContainer/index";

function* fetchCompaniesList(action) {
  try {
    const {
      page = 1,
      limit = 10,
      status,
      search,
      search_field,
      sort_by,
      sort_order
    } = action.payload || {};
    const queryParams = new URLSearchParams({ page, limit });
    if (status) queryParams.append("status", status);
    if (search) queryParams.append("search", search);
    if (search_field) queryParams.append("search_field", search_field);
    if (sort_by) queryParams.append("sort_by", sort_by);
    if (sort_order) queryParams.append("sort_order", sort_order);

    const data = yield call(
      request,
      `/api/companies?${queryParams.toString()}`,
      { method: "GET", credentials: "include" }
    );

    yield put(companiesActions.fetchCompaniesSuccess(data.data));
  } catch (error) {
    yield put(companiesActions.fetchCompaniesFailure(error.message));
  }
}

function* fetchMarketers(action) {
  try {
    const { companyId, page = 1, limit = 10 } = action.payload;
    const queryParams = new URLSearchParams({ page, limit }).toString();

    const data = yield call(
      request,
      `/api/companies/${companyId}/marketers?${queryParams}`,
      { method: "GET", credentials: "include" }
    );

    yield put(companiesActions.fetchMarketersSuccess(data.data));
  } catch (error) {
    yield put(companiesActions.fetchMarketersFailure(error.message));
  }
}

function* fetchCompanyInfoDetails() {
  try {
    const response = yield call(request, `/api/companies/updatinfodetails`, {
      method: "GET",
      credentials: "include"
    });

    if (response.success === true) {
      yield put(companiesActions.fetchCompanyInfoDetailsSuccess(response.data));
    }
  } catch (error) {
    yield put(companiesActions.fetchCompanyInfoDetailsFailure(error.message));
  }
}

function* updateCompanyDetailsSaga(action) {
  try {
    const { companyId, formData, prevSearch = "", navigate } = action.payload;

    // formData is already FormData with file + fields
    const response = yield call(
      request,
      `/api/companies/${companyId}/updateinfodetails`,
      {
        method: "POST",
        body: formData,
        credentials: "include"
      }
    );

    if (response.success) {
      const updatedData = {
        id: companyId,
        ...response.changed_fields?.reduce?.(
          (acc, field) => ({ ...acc, [field.key]: field.value }),
          {}
        )
      };

      yield put(companiesActions.updateCompanyDetailsSuccess(updatedData));
      showToast(
        response?.message || "Company updated successfully!",
        "success"
      );

      if (navigate) {
        if (window.history.state && window.history.state.idx > 0) {
          navigate(-1);
        } else {
          navigate(`/companies${prevSearch || ""}`);
        }
      }
    }
  } catch (error) {
    yield put(companiesActions.updateCompanyDetailsFailure(error.message));
    showToast(error?.message || "Update failed", "danger");
  }
}

export function* companiesSaga() {
  yield takeLatest(companiesActions.fetchCompanies.type, fetchCompaniesList);
  yield takeLatest(companiesActions.fetchMarketers.type, fetchMarketers);
  yield takeLatest(
    companiesActions.fetchCompanyInfoDetails.type,
    fetchCompanyInfoDetails
  );
  yield takeLatest(
    companiesActions.updateCompanyDetails.type,
    updateCompanyDetailsSaga
  );
}
